import type { TMoveVulnerabilityToFolderPayload } from '@/_core/entities/vulnerability/models/types';

type RouteParams = Record<string, string | undefined>;

export function buildMoveFolderPayload(
  params: RouteParams,
  vulnerabilityId: string,
  holderId: string,
  folderName: string
): TMoveVulnerabilityToFolderPayload | null {
  if (params.jobId) {
    return { jobId: params.jobId, vulnerabilityId, holderId, folderName };
  }

  if (!params.integrationId || !params.versionId) return null;

  return {
    integrationId: params.integrationId,
    versionId: params.versionId,
    vulnerabilityId,
    holderId,
    folderName,
  };
}
